var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3 0 3.58579 3.58579-3 3-3.58579-3.58579v-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.70711 12.2929 1.5 1.5-1.41422 1.4142-2.29289-2.2929-1.50229 1.5023c.00152.0276.00229.0555.00229.0835 0 .8284-.67157 1.5-1.5 1.5-.828427 0-1.5-.6716-1.5-1.5s.671573-1.5 1.5-1.5c.02802 0 .05586.0008.0835.0023l1.50229-1.5023-2.292897-2.29289 1.414217-1.41422 1.5 1.5 9.29289-9.29289h3v3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.5 16c-.8284 0-1.5-.6716-1.5-1.5 0-.028.0008-.0559.0023-.0835l-2.9165-2.9165 3.7071-3.70711 1.4142 1.41422-2.2929 2.29289 1.5023 1.5023c.0276-.0015.0555-.0023.0835-.0023.8284 0 1.5.6716 1.5 1.5s-.6716 1.5-1.5 1.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPk);
export default __webpack_public_path__ + "static/media/pk.4119b10db994d261662055140a96b740.svg";
export { ForwardRef as ReactComponent };